/** Иконки прототипа — те же пути и те же размеры. Ничего нового не рисуем. */

type P = { size?: number };

const stroke = { fill: 'none', stroke: 'currentColor', strokeWidth: 2 } as const;

export const PinIcon = ({ size = 15 }: P) => (
  <svg width={size} height={size} viewBox="0 0 24 24" {...stroke}>
    <path d="M12 21s7-6.3 7-11a7 7 0 10-14 0c0 4.7 7 11 7 11z" />
    <circle cx="12" cy="10" r="2.5" />
  </svg>
);

export const ClockIcon = ({ size = 15 }: P) => (
  <svg width={size} height={size} viewBox="0 0 24 24" {...stroke}>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 7v5l3 2" />
  </svg>
);

export const InfoIcon = ({ size = 14 }: P) => (
  <svg width={size} height={size} viewBox="0 0 24 24" {...stroke}>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 8h.01M11 12h1v4h1" />
  </svg>
);

export const WarnIcon = ({ size = 14 }: P) => (
  <svg width={size} height={size} viewBox="0 0 24 24" {...stroke}>
    <path d="M12 4l9 16H3z" />
    <path d="M12 10v4M12 17h.01" />
  </svg>
);

export const CalendarIcon = ({ size = 15 }: P) => (
  <svg width={size} height={size} viewBox="0 0 24 24" {...stroke}>
    <path d="M4 5h16v15H4z" />
    <path d="M8 3v4M16 3v4M4 10h16" />
  </svg>
);

export const BellIcon = ({ size = 15 }: P) => (
  <svg width={size} height={size} viewBox="0 0 24 24" {...stroke}>
    <path d="M18 8a6 6 0 10-12 0c0 7-2 8-2 8h16s-2-1-2-8z" />
    <path d="M10.5 20a2 2 0 003 0" />
  </svg>
);

export const MessageIcon = ({ size = 15 }: P) => (
  <svg width={size} height={size} viewBox="0 0 24 24" {...stroke}>
    <path d="M4 6h16v12H4z" />
    <path d="M4 9h16" />
  </svg>
);

export const ChevronIcon = ({ size = 17 }: P) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M9 6l6 6-6 6" />
  </svg>
);

/** Галочка в кружке варианта выбора. */
export const TickIcon = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3.2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M5 13l4 4L19 7" />
  </svg>
);

export const PencilIcon = ({ size = 18 }: P) => (
  <svg width={size} height={size} viewBox="0 0 24 24" {...stroke} strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 20h4l10-10-4-4L4 16z" />
    <path d="M13.5 6.5l4 4" />
  </svg>
);

export const PauseIcon = ({ size = 18 }: P) => (
  <svg width={size} height={size} viewBox="0 0 24 24" {...stroke} strokeLinecap="round">
    <path d="M9 5v14M15 5v14" />
  </svg>
);

export const PlayIcon = ({ size = 18 }: P) => (
  <svg width={size} height={size} viewBox="0 0 24 24" {...stroke} strokeLinejoin="round">
    <path d="M7 4l12 8-12 8z" />
  </svg>
);

export const ArchiveIcon = ({ size = 18 }: P) => (
  <svg width={size} height={size} viewBox="0 0 24 24" {...stroke} strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 7h18v3H3zM5 10v10h14V10" />
    <path d="M10 14h4" />
  </svg>
);

/** Ручка перетаскивания: за неё тащат строку в сортируемых списках. */
export const GripIcon = ({ size = 16 }: P) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
    <path d="M8 7h.01M16 7h.01M8 12h.01M16 12h.01M8 17h.01M16 17h.01" />
  </svg>
);

/** Печать на экранах «готово». */
export const SealIcon = () => (
  <svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M5 13l4 4L19 7" />
  </svg>
);

/** Две встречные стрелки — «переключить роль». */
export const SwapIcon = ({ size = 13 }: P) => (
  <svg width={size} height={size} viewBox="0 0 24 24" {...stroke} strokeLinecap="round" strokeLinejoin="round">
    <path d="M7 4L3 8l4 4" />
    <path d="M3 8h13" />
    <path d="M17 20l4-4-4-4" />
    <path d="M21 16H8" />
  </svg>
);

/** Крестик закрытия — у шторки, где большая кнопка «Закрыть» отняла бы место у действия. */
export const CloseIcon = ({ size = 18 }: P) => (
  <svg width={size} height={size} viewBox="0 0 24 24" {...stroke} strokeLinecap="round">
    <path d="M6 6l12 12M18 6L6 18" />
  </svg>
);
